import { render } from "./StoreBranding.vue?vue&type=template&id=b2a79f2c&scoped=true"
import script from "./StoreBranding.vue?vue&type=script&lang=js"
export * from "./StoreBranding.vue?vue&type=script&lang=js"

import "./StoreBranding.vue?vue&type=style&index=0&id=b2a79f2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2a79f2c"]])

export default __exports__